export async function fileToBase64(file: File): Promise<string> {
  const fileReader = new FileReader();

  const promise = new Promise((resolve, reject) => {
    fileReader.onload = resolve;
    fileReader.onerror = reject;
    fileReader.readAsDataURL(file);
  });

  await promise;

  return fileReader.result as string;
}

export async function fileToBuffer(file: File): Promise<Buffer> {
  const fileReader = new FileReader();

  const promise = new Promise((resolve, reject) => {
    fileReader.onload = resolve;
    fileReader.onerror = reject;
    fileReader.readAsArrayBuffer(file);
  });

  await promise;

  return fileReader.result as Buffer;
}
